var map = {
	"./b2b-img1.jpg": 962,
	"./b2b-img2.jpg": 963,
	"./b2b-img3.jpg": 964,
	"./b2b-img4.jpg": 965,
	"./b2b-img5.jpg": 966,
	"./b2b-img6.jpg": 967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1814;